import type { ComponentPropsWithoutRef, ReactNode } from "react";
import type { Link as ReactLink } from "react-router";

interface LinkProps extends ComponentPropsWithoutRef<typeof ReactLink> {
    button?: boolean;
    native?: boolean;
    secondary?: boolean;
    fullWidth?: boolean;
    disabled?: boolean;
    size?: "small" | "large" | "";
    cursor?: "pointer" | "default";
    ariaLabel?: string;
    "aria-label"?: string;
    children?: ReactNode;
}

const Link = ({
    to = "",
    className = "",
    children,
    secondary,
    fullWidth,
    disabled,
    button,
    native,
    size,
    cursor,
    ariaLabel,
    "aria-label": ariaLabelDash,
    ...linkProps
}: LinkProps) => {
    const getBtnClassname = () => {
        if (button) {
            switch (size) {
                case "small":
                    return "btn btn-sm";
                case "large":
                    return "btn btn-lg";
                default:
                    return "btn";
            }
        } else {
            switch (size) {
                case "small":
                    return "link link-sm";
                case "large":
                    return "link link-lg";
                default:
                    return "link";
            }
        }
    };

    const mergeClassNames = () => {
        return `${className} ${getBtnClassname()} ${button ? "btn-anchor" : ""} ${disabled ? "disabled" : ""} ${secondary ? "btn-secondary" : ""} ${fullWidth ? "w-full" : ""} ${cursor ? `cursor-${cursor}` : !disabled ? "cursor-pointer" : ""}`.trim();
    };

    const accessibleName = ariaLabel || ariaLabelDash;

    if (native) {
        return (
            <Link className={mergeClassNames()} to={to} aria-label={accessibleName} {...linkProps}>
                {" "}
                {children}{" "}
            </Link>
        );
    }

    return (
        <a className={mergeClassNames()} href={to.toString()} aria-label={accessibleName} {...linkProps}>
            {children}
        </a>
    );
};

export default Link;
